import { render, staticRenderFns } from "./DForm.vue?vue&type=template&id=6bfd1a68&scoped=true"
import script from "./DForm.vue?vue&type=script&lang=js"
export * from "./DForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfd1a68",
  null
  
)

export default component.exports